import styled from 'styled-components';

import { captionRegular } from 'styles/mixins/fonts';

export const EventPercent = styled.p`
  ${captionRegular};
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

// The Details card sits inside GeneralInfo's container (padding 16px); a card
// that continues it (Car rental) takes the same inset so the edges and the
// 4-column grid line up (V32).
export const DetailsAligned = styled.div`
  padding: 0 16px;
`;
